import React from 'react';
import TaskSectionPage from '../components/TaskSectionPage';

const Vocabulary: React.FC = () => {
  return (
    <TaskSectionPage
      section="vocabulary"
      title="Vocabulary"
      description="Expand your English vocabulary through themed word practice and context-based exercises."
    />
  );
};

export default Vocabulary;